import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterEditor, FilterRecord, Operator } from '@services/core-services/filters';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs';

@Component({
  selector: 'app-filter-entry-editor-number',
  imports: [CommonModule, InputsComponent, ReactiveFormsModule],
  templateUrl: './filter-entry-editor-number.component.html',
  styleUrl: './filter-entry-editor-number.component.scss',
})
export class FilterEntryEditorNumberComponent implements FilterEditor {
  private _record!: FilterRecord;

  get record(): FilterRecord {
    return this._record;
  }

  @Input()
  set record(record: FilterRecord) {
    this._record = record;
    this.initialize(record);
  }

  get isRange(): boolean {
    return Operator.Between === this.record.rule.operator;
  }

  @Output() onChange: EventEmitter<string | string[]> = new EventEmitter<string | string[]>();

  public inputCtrlFrom = new FormControl();
  public inputCtrlTo = new FormControl();

  constructor() {
    this.inputCtrlFrom.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      const t = this.inputCtrlTo.value || '';
      this.emitValue(value, t);
    });

    this.inputCtrlTo.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      const f = this.inputCtrlFrom.value || '';
      this.emitValue(f, value);
    });
  }

  private initialize(record: FilterRecord) {
    const value = record.rule.value || '';
    if (Array.isArray(value)) {
      this.inputCtrlFrom.setValue(record.rule.value[0] || '', { emitEvent: false });
      this.inputCtrlTo.setValue(record.rule.value[1] || '', { emitEvent: false });
    } else {
      this.inputCtrlFrom.setValue(record.rule.value || '', { emitEvent: false });
    }
  }

  private emitValue(from?: number, to?: number) {
    const f = from?.toString() || '';
    const t = to?.toString() || '';
    this.onChange.emit(this.isRange ? [f, t] : f);
  }
}
